import type { VariableObject } from '$lib/config-schemas/has-variables';

export const getDisplayNameFromVariable = (
  variable: VariableObject,
  { includeDefault = true }: { includeDefault?: boolean } = {}
): string => {
  const { name, default_value: defaultValue } = variable.$variable;
  if (defaultValue !== undefined && includeDefault) {
    const defaultStr =
      typeof defaultValue === 'string'
        ? defaultValue
        : JSON.stringify(defaultValue);
    return `$var:${name} (default: ${defaultStr})`;
  }
  return `$var:${name}`;
};

export const extractVariableNameFromProp = (prop: unknown): string => {
  return getDisplayNameFromVariable(prop as VariableObject);
};
